/**
 * @fileoverview Ponto de entrada responsável por preparar o runtime do frontend e montar a aplicação no DOM.
 */

import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import App from "./App";

// Polyfill: garante que process.env existe sem sobrescrever valores do CRA
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: { NODE_ENV: 'development' } };
}
if (typeof global !== 'undefined' && !global.process) { // eslint-disable-line no-undef
  global.process = { env: { NODE_ENV: 'development' } }; // eslint-disable-line no-undef
}

// Silenciar warnings do Material-UI, React e Webpack em desenvolvimento
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;
const originalConsoleInfo = console.info;

console.error = (...args) => {
  const message = args[0];
  
  // Silenciar warnings específicos do Material-UI
  if (typeof message === 'string') {
    if (message.includes('Material-UI:') || 
        message.includes('Warning: Failed prop type:') ||
        message.includes('Warning: React Hook') ||
        message.includes('Warning: You are providing') ||
        message.includes('Warning: You used an element after') ||
        message.includes('Warning: The Menu component') ||
        message.includes('no-unused-vars') ||
        message.includes('react-hooks/exhaustive-deps')) {
      return; // Silencia esses warnings
    }
  }
  
  // Manter outros erros importantes
  originalConsoleError.apply(console, args);
};

console.warn = (...args) => {
  const message = args[0];
  
  // Silenciar warnings específicos do Material-UI, React e Webpack
  if (typeof message === 'string') {
    if (message.includes('Material-UI:') || 
        message.includes('Warning: Failed prop type:') ||
        message.includes('Warning: React Hook') ||
        message.includes('Warning: You are providing') ||
        message.includes('Warning: You used an element after') ||
        message.includes('Warning: The Menu component') ||
        message.includes('no-unused-vars') ||
        message.includes('react-hooks/exhaustive-deps') ||
        message.includes('There were more warnings in other files') ||
        message.includes('You can find a complete log in the terminal')) {
      return; // Silencia esses warnings
    }
  }
  
  // Manter outros warnings importantes
  originalConsoleWarn.apply(console, args);
};

console.info = (...args) => {
  const message = args[0];
  
  // Silenciar informações do HMR e webpack
  if (typeof message === 'string') {
    if (message.includes('[HMR]') || 
        message.includes('Download the React DevTools') ||
        message.includes('webpackHotDevClient')) {
      return; // Silencia essas informações
    }
  }
  
  // Manter outras informações importantes
  originalConsoleInfo.apply(console, args);
};

// Silenciar logs no ambiente de produção
// TEMPORARIAMENTE DESABILITADO PARA DEBUG DE REAÇÕES
/*
if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.error = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
}
*/

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
